// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-spacer {
  padding-left: 18px;
  padding-top: 1px;
  font-size: 17px;
  color: var(--theme-main-color, #055C8D);
}

.toolbar-header {
  height: 48px;
  font-family: Inter !important;
  width: 100%;
}

.main-content {
  background-color: #f3f3f3;
  margin-left: 10px;
}

.notification-button {
  margin: 0 0 0 auto;
}

mat-toolbar {
  background-color: #ffffff;
  padding: 0px 15px;
  display: flex;
  z-index: 990;
  height: 64px;
}

.toolbar-headings {
  justify-content: flex-start;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 100%;
  margin-left: 30px;
  padding: 14px 16px;
}

a {
  color: #859296;
}
a:hover {
  color: var(--theme-active-alternate-color, #055C8D);
}

.active-heading {
  color: var(--theme-main-color, #055C8D);
}

.routing-container {
  padding-right: 0px;
  min-width: 430px;
  width: 100%;
}

.help-link {
  padding-top: 0px;
  height: 40px;
  width: 25px;
  margin-left: 8px;
}

.help-icon {
  padding-top: 5px;
  padding-left: 0px;
}

.link {
  cursor: pointer;
  color: var(--theme-main-color, #055C8D);
  font-size: 20px;
}

.link:hover {
  color: var(--theme-main-darker-color, #055C8D);
}

.heading-item-padding {
  padding: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
